@if (show_()) {
    <mat-progress-bar [mode]="mode" [value]="progress"></mat-progress-bar>
}
